import { Component, OnInit, ɵConsole } from '@angular/core';

import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FuseConfigService } from '../../../core/services/config.service';
import { fuseAnimations } from '../../../core/animations';
import { LoginModel } from './Login.model'
import { ServiciosGenerales } from '../Servicios/ServiciosGenerales.service';
import { MatSnackBar } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';
import { md5 } from '../Global/md5';
import { IfObservable } from 'rxjs/observable/IfObservable';


export interface FormModel {
    captcha?: string;
}

@Component({
    selector: 'fuse-forgot-password-2',
    templateUrl: './forgot-password-2.component.html',
    styleUrls: ['./forgot-password-2.component.scss'],
    animations: fuseAnimations
})
export class FuseForgotPassword2Component implements OnInit {
    forgotPasswordForm: FormGroup;
    forgotPasswordFormErrors: any;
    public datosLogin: LoginModel;

    public captcha: string;
    public formModel: FormModel = {};

    private timeInterval: any = undefined;
    public bloquearCampo: boolean = true;
    public bloquearCampoNormal: boolean = false;
    public load: boolean = false;
    public mensajeTemporizador: string = 'HOLLAAA';

    public ocultar: boolean = false;
    public mensaje: string = "";

    constructor(
        private fuseConfig: FuseConfigService,
        private _serviciosGenerales: ServiciosGenerales,
        private router: Router,
        private formBuilder: FormBuilder,
        public snackBar: MatSnackBar
    ) {
        this.fuseConfig.setSettings({
            layout: {
                navigation: 'none',
                toolbar: 'none',
                footer: 'none'
            }
        });

        this.forgotPasswordFormErrors = {

            usuario: {},
            password: {},
            empresa: {},
            confirmPassword: {},
            codigoConfirmacion: {}
        };

        this.datosLogin = new LoginModel("", "", "", "", "");
        this.snackBar.dismiss();
    }

    ngOnInit() {
        this.inicializarForm(true);
    }
    //                String expresionRegular="(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[! \" # $ % & ' ( ) * + , \\ -. / : ; < = > ? @ [ ] ^ _ ` { | }])(?=\\S+$).{14,30}";
    inicializarForm(generarSubcribe: boolean) {
        this.forgotPasswordForm = this.formBuilder.group({
            usuario: [{ disabled: this.bloquearCampoNormal, value: this.datosLogin.usuario }, [Validators.required, Validators.maxLength(20)]],
            empresa: [{ disabled: this.bloquearCampoNormal, value: this.datosLogin.empresa }, [Validators.required, Validators.maxLength(20)]],
            password: [{ disabled: this.bloquearCampoNormal, value: this.datosLogin.clave }, [Validators.required, Validators.pattern(/(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[$@$!%/*?&#.$($)$-$_])[A-Za-z\d$@$!%*?&#.$($)$-$_].{14,30}/)]],
            confirmPassword: [{ disabled: this.bloquearCampoNormal, value: this.datosLogin.comfirmClave }, [Validators.required, Validators.maxLength(30)]],
            codigoConfirmacion: [{ disabled: this.bloquearCampo, value: this.datosLogin.codigoConfirmacion }, [Validators.required, Validators.maxLength(10)]]

        });
        if (generarSubcribe == true) {
            this.forgotPasswordForm.valueChanges.subscribe(() => {
                this.onForgotPasswordFormValuesChanged();
            });
        }

    }


    generarCodigo() {
        if (!this.forgotPasswordForm.valid) {
            this.openSnackBarEspecial("Favor completar correctamente todos los campos", "X");
            return
        }
        if (this.datosLogin.clave != this.datosLogin.comfirmClave) {
            this.openSnackBarEspecial("Las claves no coninciden", "X");
            return;
        }

        this.mensajeTemporizador = 'INICIA.. . ';
        let conteo = 300;
        this.load = true;

        this._serviciosGenerales.post("usuario/login/generar/codigo", { usuario: this.datosLogin.usuario, clave: "", empresa: this.datosLogin.empresa }).subscribe(res => {


            this.datosLogin.codigoConfirmacion = '';

            if (res.error == false) {

                this.bloquearCampoNormal = true;
                this.bloquearCampo = false;


                this.inicializarForm(false);

                this.timeInterval = setInterval(() => {
                    document.getElementById('codigoConfirmacion').focus();
                    conteo = conteo - 1;

                    document.getElementById("mensaje").innerHTML = ('Tiempo Restante: ' + conteo.toString());


                    // console.log("CUENTA ", conteo, ' <------> ', (conteo <= 0));
                    if (conteo <= 0) {

                        document.getElementById("mensaje").innerHTML = ('El Tiempo ha vencido, por favor genere un nuevo código');

                        clearInterval(this.timeInterval);

                        this.load = false;
                        this.bloquearCampoNormal = false;
                        this.bloquearCampo = true;
                        this.inicializarForm(false);
                        this.datosLogin.codigoConfirmacion = '';

                        setTimeout(() => {
                            document.getElementById("empresa").focus();
                        }, 500)
                    }
                }, 1000);
            } else {
                this.load = false;
                this.bloquearCampoNormal = false;
                this.bloquearCampo = true;
                this.inicializarForm(false);
                this.datosLogin.codigoConfirmacion = '';
            }

            this.openSnackBar(res.mensaje, "X");

        }, error => {
            this.openSnackBarEspecial(error, "X");
            this.load = false;
            this.bloquearCampoNormal = false;
            this.bloquearCampo = true;
            this.inicializarForm(false);
            this.datosLogin.codigoConfirmacion = '';

        })
    }

    validarCodigo() {
        //console.log("-------------------> ");
        this._serviciosGenerales.post("usuario/login/validar/codigo/" + this.datosLogin.codigoConfirmacion,{ usuario: this.datosLogin.usuario, clave: this.datosLogin.clave, empresa: this.datosLogin.empresa }).subscribe(res => {
            if (res.error == false) {
                this.router.navigate(['/login']);
                clearInterval(this.timeInterval);
            }


            this.openSnackBar(res.mensaje, "X");



        }, error => {
            this.openSnackBarEspecial("Error: La solicitud no fue Válida", "X");
        })
    }



    resolved(captchaResponse: string) {
        /*let info = {
            secret : '6LdA20AUAAAAALmD88Key0czhekh_AkOvuxwzav9',
            response : captchaResponse
        }
        this._serviciosGenerales.postUrlSpecial('https://www.google.com/recaptcha/api/siteverify', info).subscribe(result=>{
            console.log(result);
            if(result['success'] == false){
                this.openSnackBar('Ocurrió un error al momento de validar el Captcha, por favor recargue la página', 'X');
                return;
            }
            this.captcha = false;
    
        },error=>{
            this.openSnackBar('Ocurrió un error al momento de validar el Captcha, por favor recargue la página', 'X');
            console.log('', error);
    
        })*/
        /*console.log('',captchaResponse);
        console.log(`Resolved captcha with response ${captchaResponse}:`);*/
    }

    onForgotPasswordFormValuesChanged() {
        for (const field in this.forgotPasswordFormErrors) {
            if (!this.forgotPasswordFormErrors.hasOwnProperty(field)) {
                continue;
            }

            // Clear previous errors
            this.forgotPasswordFormErrors[field] = {};

            // Get the control
            const control = this.forgotPasswordFormErrors[field];

            if (control && control.dirty && !control.valid) {
                this.forgotPasswordFormErrors[field] = control.errors;
            }
        }
    }

    openSnackBar(message: string, action: string) {
        this.snackBar.open(message, action, {
            duration: 20000
        });
    }

    openSnackBarEspecial(message: string, action: string) {
        let snackBarRef = this.snackBar.open(message, action);

        snackBarRef.onAction().subscribe(() => {

            this.ocultar = false;
            this.mensaje = "";
        });

        let shand = document.getElementsByClassName('mat-snack-bar-container') as HTMLCollectionOf<HTMLElement>;

        if (shand.length != 0) {
            for (let i = 0; i < shand.length; i++) {
                shand[i].style.backgroundColor = "rgb(255 204 214)";
            }
        }
    }



}



// WEBPACK FOOTER //
// D:/REPO/FacturacionWeb/src/app/main/content/forgot-password-2/forgot-password-2.component.ts